export default "__VITE_ASSET__CEs2if5X__"